var FuseNavigationModule = /** @class */ (function () {
    function FuseNavigationModule() {
    }
    return FuseNavigationModule;
}());
export { FuseNavigationModule };
